// Auth
export const urlRefreshToken = 'auth/refresh-token';
export const urlApiAuth = {
  login: 'auth/login',
  refreshToken: 'auth/refresh-token',
};
